import {action, observable} from 'mobx'
import {Intent} from '../theme'

interface INotification {
  message?: string
  type?: Intent
  sticky?: boolean
}

export class NotificationStore {
  @observable
  notification: INotification = {}

  @action
  showNotification = (notification: INotification) => {
    this.notification = notification
  }

  @action
  hideNotification = () => {
    this.notification = {}
  }
}
